"use client";

import { c as _c } from "react/compiler-runtime";
import { Separator } from "@/components/ui/separator";
import { Toaster } from "@/components/ui/sonner";
import { Container } from "./container";
import Logo from "./logo";
import { Mail, MapPin, Phone } from "lucide-react";
import Link from "next/link";
import { DISCLAIMERS, FOOTER_LINLS, PHONES, TERMS_PAGES } from "@/lib/site-config";
import Image from "next/image";
import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from "./common/social-icons";
const socials = [{
  label: "Facebook",
  icon: FacebookIcon,
  link: "https://www.facebook.com/spoclearn"
}, {
  label: "LinkedIn",
  icon: LinkedinIcon,
  link: "https://www.linkedin.com/company/spoclearn/"
}, {
  label: "Instagram",
  icon: InstagramIcon,
  link: "https://www.instagram.com/spoclearn/"
}, {
  label: "YouTube",
  icon: YoutubeIcon,
  link: "https://www.youtube.com/channel/UC7UKhbbPfDDjUJWdtM0NpZw"
}];
export default function Footer() {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Toaster />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">{FOOTER_LINLS.map(_temp2)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/" title="Spoclearn"><Logo className="grayscale transition-colors duration-300 hover:grayscale-0" width={175} /></Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li className="flex items-center gap-1"><Mail size={16} className="text-primary" /><a href="mailto:info@spoclearn.com">{"info(at)spoclearn(dot)com"}</a></li>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li className="flex items-center gap-1"><Phone size={16} className="text-primary" /><a href="tel:+1 (908) 293 7144">{"+1 (908) 293 7144"}</a></li>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="grid gap-12 lg:grid-cols-[2fr_1.2fr] lg:gap-16">{t1}<div className="max-w-sm">{t2}<ul className="text-muted-foreground mt-3">{t3}{t4}<li className="flex items-baseline gap-1"><MapPin size={16} className="text-primary mt-1 shrink-0" /><span><b className="block text-sm font-bold tracking-tight">United States</b>3500 S Dupont Hwy Suite DK 101, Dover, DE 19901, United States</span></li></ul></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-8 flex flex-wrap items-center gap-3">{PHONES.map(_temp3)}</div>;
    t7 = <Separator className="my-6" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="text-sm font-bold tracking-tight">Disclaimer</div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Container>{t0}{t5}{t6}{t7}<div className="">{t8}<ul className="mt-4 ml-3 flex list-disc flex-col gap-2">{DISCLAIMERS.map(_temp4)}</ul></div></Container>;
    t10 = <Separator className="mt-12" />;
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="text-muted-foreground text-sm">© 2020 - 2026 | All Rights Reserved</p>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ul className="flex flex-col gap-3 text-xs sm:flex-row sm:items-center">{TERMS_PAGES.map(_temp5)}</ul>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <footer className="pt-10 not-dark:border-t">{t9}{t10}<Container><div className="flex flex-col items-start gap-4 py-5 sm:flex-row sm:items-center sm:justify-between">{t11}{t12}<div className="flex items-center gap-2">{socials.map(_temp6)}</div></div></Container></footer>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  return t13;
}
function _temp6(social) {
  return <a key={social.label} href={social.link} aria-label={social.label} target="_blank" rel="noopener noreferrer" className="border-border bg-background text-muted-foreground hover:text-foreground rounded-sm border p-2 transition-colors"><social.icon className="size-4" aria-hidden="true" /></a>;
}
function _temp5(item_1) {
  return <li key={item_1.link}><Link href={item_1.link} className="text-muted-foreground hover:text-foreground transition-colors" prefetch={false}>{item_1.name}</Link></li>;
}
function _temp4(disclaimer, idx) {
  return <li key={`disclaimer-${idx}`} className="text-muted-foreground hover:text-foreground text-xs transition-colors">{disclaimer}</li>;
}
function _temp3(item_0) {
  return <a key={item_0.country} href={`tel:${item_0.value}`} className="flex items-center gap-2"><span className="h-3 w-5"><Image src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${item_0.country}.svg`} alt={item_0.country} title={item_0.country} width={24} height={16} className="rounded-xs object-cover" /></span>{item_0.label}</a>;
}
function _temp2(col) {
  return <div key={col.title}><div className="text-sm font-bold tracking-tight">{col.title}</div><ul className="mt-4 flex flex-col gap-3">{col.links.map(_temp)}</ul></div>;
}
function _temp(item) {
  return <li key={item.link}><Link href={item.link} className="text-muted-foreground hover:text-foreground text-sm transition-colors" prefetch={false}>{item.label}</Link></li>;
}